import { render, staticRenderFns } from "./moreHDPH.vue?vue&type=template&id=4a4dacdb&lang=pug&"
import script from "./moreHDPH.vue?vue&type=script&lang=js&"
export * from "./moreHDPH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports